



















import { Component, Vue, Prop } from 'vue-property-decorator';
import SelectRole from '@/components/selectRole.vue';

type IRoleInfo = IRole.IResponse.IRoleInfo;

@Component({
  components: {
    SelectRole,
  },
})
export default class EditTeams extends Vue {
  @Prop({required: true}) private type!: 'add' | 'del';
  @Prop({default: () => []}) private roles!: IRoleInfo[];
  @Prop({required: true}) private submitAddRoles!: (
    roleIds: string[],
  ) => Promise<string>;
  @Prop({required: true}) private submitDelRoles!: (
    roleIds: string[],
  ) => Promise<string>;
  private mode = 'multiple';
  private loading = false;
  private selectedList: string[] = [];
  private removedList: string[] = [];
  private currentRoles: IRoleInfo[] = [];
  private created() {
    this.resetEdit();
  }
  // 获取当前的roleIds
  get currentRoleIds() {
    return this.currentRoles.map((role) => role.id);
  }
  // 处理选项改变
  private handleChange(value: string[]) {
    if (this.mode === 'multiple') {
      this.selectedList = value;
    }
  }
  // 重置编辑数据
  private resetEdit() {
    this.selectedList = [];
    this.removedList = [];
    this.currentRoles = [...this.roles];
  }
  private removeCurrentRoles(roleId: string) {
    const newcurrentRoles = this.currentRoles.filter((role) => role.id !== roleId);
    this.currentRoles = newcurrentRoles;
    this.removedList.push(roleId);
  }
  private handleAddRoles() {
    if (this.selectedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitAddRoles(this.selectedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
  private handleDelRoles() {
    if (this.removedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitDelRoles(this.removedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
}
